module.exports = __webpack_public_path__ + "img/q4.7535fbbb.png";